package com.example.positionahead.domain

fun resolveLiveQuotePrice(price: Double, previousClose: Double?): Double =
    price.takeIf { it > 0 } ?: previousClose?.takeIf { it > 0 } ?: 0.0
